module.exports = __webpack_public_path__ + "static/avatar-1b58dfe1fa1ea593c44cd7b560dcde93.jpg";